import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  detailsItem: {
    borderRadius: 12,
    padding: 14,
    backgroundColor: token.lightGrey.lightGrey3,
    color: token.black.black1
  }
}))
